export const API_SERVER = process.env.REACT_APP_API_SERVER
export const API_ROOT = process.env.REACT_APP_API_ROOT
export const API_VERSION = process.env.REACT_APP_API_VERSION
export const ENTRYPOINT = `${API_ROOT}/${API_VERSION}`;